export const VISIBLE_QUALIFICATION_ATTRIBUTE_INPUT_SOURCES = [
  'admin',
  'user',
  'agency',
  'user_automation',
  'system',
];
